<template>
	<div class="row w100 " :class="[gutter, gap, loadingClass]">
		<div v-for="(item, index) in localItems" :key="`infinite-${index}`" :class="columnClass">
			<slot name="item" :item="item">{{ item }}</slot>
		</div>

		<infinite-loading class="w100" @infinite="infiniteHandler" :identifier="localIdentifier">
			<div slot="spinner">
				<div class="align-center">
					<span
						><b-icon spin><b-icon-refresh class="font-size-xhuge"/></b-icon
					></span>
				</div>
			</div>
			<div slot="no-more"></div>
			<div slot="no-results"></div>
		</infinite-loading>
	</div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import BIcon from './Icon.vue';
import BIconRefresh from '../icons/icon-refresh.svg';

export default {
	components: {
		InfiniteLoading,
		BIcon,
		BIconRefresh
	},
	props: {
		/**
		 * Array com todos os elementos que devem ser exibidos
		 * Se e o scroll estiver na página 2, deve conter os elementos das páginas 0, 1 e 2
		 *
		 */
		items: {
			type: Array,
			default: () => []
		},
		/**
		 * Seta o valor inicial da paginação
		 */
		initialPage: {
			type: Number,
			default: 0
		},
		/**
		 * Seta quantas colunas vão compor o loading infinito,
		 * @values 1, 2, 3, 4, 6
		 */
		columns: {
			type: Number,
			default: 3,
			validator: function(value) {
				return [1, 2, 3, 4, 6].indexOf(value) !== -1;
			}
		},
		/**
		 * Quando este valor é alterado os elementos exibidos
		 * na listagem são resetados e ela volta para o estado inicial
		 */
		identifier: {
			type: String,
			default: 'infinite-loading'
		}
	},
	data() {
		return {
			page: 0,
			localItems: [],
			localIdentifier: '',
			state: null,
			complete: false
		};
	},
	computed: {
		gutter() {
			const gutterClasses = {
				1: '',
				2: 'cols-lg-gutter-normal',
				3: 'cols-md-gutter-tiny cols-lg-gutter-normal',
				4: 'cols-md-gutter-tiny cols-lg-gutter-normal',
				6: 'cols-gutter-xtiny cols-md-gutter-tiny cols-lg-gutter-normal'
			};

			return gutterClasses[this.columns];
		},
		gap() {
			const gapClasses = {
				1: 'cols-gap-normal cols-md-gap-big',
				2: 'cols-gap-normal cols-md-gap-big',
				3: 'cols-gap-normal cols-lg-gap-big',
				4: 'cols-gap-normal  cols-lg-gap-big',
				6: 'cols-gap-tiny cols-md-gap-normal cols-lg-gap-big'
			};

			return gapClasses[this.columns];
		},
		loadingClass() {
			const loadingClasses = {
				1: 'margin-bottom-normal margin-bottom-md-big',
				2: 'margin-bottom-normal margin-bottom-md-big',
				3: 'margin-bottom-normal margin-bottom-lg-big',
				4: 'margin-bottom-normal  margin-bottom-lg-big',
				6: 'margin-bottom-tiny margin-bottom-md-normal margin-bottom-lg-big'
			};

			return this.complete ? '' : loadingClasses[this.columns];
		},
		columnClass() {
			const columnClasses = {
				1: 'col-12',
				2: 'col-12 col-lg-6',
				3: 'col-12 col-md-6 col-xl-4',
				4: 'col-12 col-md-6 col-lg-4 col-xl-3',
				6: 'col-6 col-md-4 col-xl-2'
			};

			return columnClasses[this.columns] ? columnClasses[this.columns] : columnClasses[3];
		}
	},
	watch: {
		items: function(newItems, oldItems) {
			this.localItems = newItems;
			if (this.state) {
				if (newItems.length !== oldItems.length) this.state.loaded();
				else {
					this.state.complete();
					this.complete = true;
				}
			}
		},
		identifier: function(newIdentifier, oldIdentifier) {
			if (newIdentifier !== oldIdentifier) {
				this.localItems = [];
				this.page = this.initialPage;
				this.localIdentifier = newIdentifier;
			}
		}
	},
	mounted() {
		this.page = this.initialPage;
		this.localItems = this.items;
		this.localIdentifier = this.identifier;
	},
	methods: {
		infiniteHandler($state) {
			this.state = $state;
			this.page += 1;
			/**
			 * Evento emitido quando usuário faz o movimento de scroll ao final da página, 
			 * enquanto ainda existem elementos para serem carregados
			 *
			 * @property {number} valor da página alcançada
			 */
			this.$emit('infiniteScroll', this.page);
		}
	}
};
</script>

<style></style>
